import { useEffect } from 'react'
import {useAuthContext} from '../hooks/useAuthContext'
import{useState} from 'react'

const Accountinfo = () => {
   
    const {user}= useAuthContext()
    const [referall,setReferall] =useState(null)

    useEffect(() => {
     const fetchtuckshop = async () => {
        const response = await fetch('https://webservicetry1.onrender.com/api/referall/referall')
        const json = await response.json()
        const jsons = json.filter(name => name.referall === user.referallcode)
        const keys = Object.keys(jsons).length
        if (response.ok) { setReferall(keys)}
     }
    fetchtuckshop()
    })
    
    
return (
    <div className='accountInfo'>
    <p><strong>email: </strong>{user.email}</p> 
    <p><strong>Name: </strong>{user.name}</p> 
    <p><strong>Surname: </strong>{user.surname}</p> 
    <p><strong>No ID: </strong>{user.nationalID}</p> 
    <p><strong>Tuckshop Name: </strong>{user.tuckshopname}</p>
    <p><strong>Contact details:</strong>{user.contacts}</p>
    <p><strong>Referee: </strong>{user.referall}</p> 
    <p><strong>Referal Code: </strong> https://matuckshop.netlify.app/signup/{user.referallcode}</p> 
    <p><strong>Number of referalls: </strong>{referall}</p> 
    <div className='Balance'>Account Balance:{user.balance}</div>
    </div>


   
)
}

export default Accountinfo